module.exports = __webpack_public_path__ + "static/media/summit-confirm-face-register.4b591078.svg";